import Vue from "vue";

const STORAGE_ENGINE = sessionStorage;


const UserInfoTool = {
    getEngine() {
        return STORAGE_ENGINE
    },

    setToken(token) {
        STORAGE_ENGINE.setItem('_token', token);
    },

    // 获取用户Token
    getToken() {
        return STORAGE_ENGINE.getItem('_token');
    },

    setUser(user) {
        STORAGE_ENGINE.setItem('__user__', user);
    },

    // 获取用户信息
    getUser() {
        return STORAGE_ENGINE.getItem('__user__');
    },

    setItem(key, val) {
        if (typeof val === 'object') {
            STORAGE_ENGINE.setItem(key, JSON.stringify(val))
        } else {
            STORAGE_ENGINE.setItem(key, val)
        }
    },

    getItem(key) {
        let ele = STORAGE_ENGINE.getItem(key);
        let val = null;
        try {
            val = JSON.parse(ele);
        } catch (error) {
            val = ele;
        }
        return val;
    },
    removeItem(key) {
        STORAGE_ENGINE.removeItem(key);
    },
    clear() {
        STORAGE_ENGINE.clear();
    }
};

Vue.prototype.$userInfoTool = UserInfoTool;

export default UserInfoTool;
